import axios from '../utils/axios';

export default function fetchCourseMapping(adminId, courseId, params) {
    return (
        axios.get('/admin/' + adminId + '/courses/course-mapping/' + courseId, { params })
    )
}
